import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { environment } from '@platri/elab-angular-environments';
import * as i1 from '@angular/common/http';
import { AbstractHttpService, setParamsFromObject, AbstractStateV2Service, AbstractStateService, getSubscription } from '@platri/elab-angular-core';
import { map, BehaviorSubject, Subscription } from 'rxjs';

class GetAllPokemonResponseDto {
}

class PokemonDto {
}

const AuctionFeatureToggle = "Auction";

const PlatoTwitterHandleIdRouterParam = 'twitter-handle-id';

const PokemonNameRouterParam = 'pokemonName';

const ChatAppChatRouterParam = 'recipient-id';
const ChatAppChatsTechnicalUserRouterQueryParam = 'technicalUserId';

const BestPractiseAppTwoRoute = 'best-practise-app-two';
const BestPractiseAppTwoAuctionsRoute = 'auctions';
const BestPractiseAppTwoAuctionsPokemonNameRoute = ((pokemonName) => BestPractiseAppTwoAuctionsPokemonNameRouteHelper(pokemonName));
function BestPractiseAppTwoAuctionsPokemonNameRouteHelper(pokemonName = ':' + PokemonNameRouterParam) {
    return `/${BestPractiseAppTwoRoute}/${BestPractiseAppTwoAuctionsRoute}/${pokemonName}`;
}

const BestPractiseAppRoute = 'best-practise-app';
const BestPractiseAppPokedexRoute = 'pokedex';

const PlatoAppRoute = 'plato-app';
const PlatoLandingRoute = 'landing-page';
const PlatoLoginRoute = 'login';
const PlatoRegisterRoute = 'register';
const PlatoHomeRoute = 'home';
const PlatoCreateTwitterHandleRoute = 'create-twitter-handle';
const PlatoTwitterHandleDetailIdRoute = ((id) => PlatoTwitterHandleDetailIdRouteHelper(id));
function PlatoTwitterHandleDetailIdRouteHelper(id = ':' + PlatoTwitterHandleIdRouterParam) {
    return `/${PlatoAppRoute}/${PlatoHomeRoute}/${id}`;
}

const ChatAppRoute = 'chat-app';
const ChatAppChatsRoute = 'chats';
const ChatAppChatsCurrentUserRoute = 'current-user';
const ChatAppChatRoute = 'chat';

const AuthAppRoute = 'auth-app';

class FeatureToggleHttpService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.baseUrl = environment.webEndpoints.bestPractiseApi;
        console.log('Initializing FeatureToggleHttpService');
    }
    ngOnDestroy() {
        console.log('Destroying FeatureToggleHttpService');
    }
    getAllFeatureToggles() {
        return this.httpClient.get(this.baseUrl + 'feature-toggle');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: FeatureToggleHttpService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: FeatureToggleHttpService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: FeatureToggleHttpService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

class FeatureToggleService {
    constructor() {
        console.log('Initializing FeatureToggleService');
    }
    ngOnDestroy() {
        console.log('Destroying FeatureToggleService');
    }
    getActiveFeatureToggleStrings(featureToggles) {
        return featureToggles.filter(featureToggle => featureToggle.active).map(featureToggle => featureToggle.name);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: FeatureToggleService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: FeatureToggleService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: FeatureToggleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [] });

class PokemonHttpWithAbstractService extends AbstractHttpService {
    constructor(httpClient) {
        console.log('Initializing ' + PokemonHttpWithAbstractService.name);
        super(environment.webEndpoints.pokemonApi);
        this.httpClient = httpClient;
    }
    ngOnDestroy() {
        console.log('Destroying ' + PokemonHttpWithAbstractService.name);
    }
    getAllPokemon() {
        // We will just load the first 151 Pokemons to make things simple.
        const params = setParamsFromObject({ offset: 0, limit: 151 });
        return this.httpClient.get(this.baseUrl + 'pokemon', { params });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonHttpWithAbstractService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonHttpWithAbstractService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonHttpWithAbstractService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

class PokemonHttpService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.baseUrl = environment.webEndpoints.pokemonApi;
        console.log('Initializing PokemonHttpService');
    }
    ngOnDestroy() {
        console.log('Destroying PokemonService');
    }
    getAllPokemon() {
        // We will just load the first 151 Pokemons to make things simple.
        const params = setParamsFromObject({ offset: 0, limit: 151 });
        return this.httpClient.get(this.baseUrl + 'pokemon', { params });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonHttpService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonHttpService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonHttpService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

class PokemonService {
    constructor() {
        console.log('Initializing PokemonService');
    }
    ngOnDestroy() {
        console.log('Destroying PokemonService');
    }
    getImageUrlForPokemon(pokemonId) {
        return environment.webEndpoints.pokemonSpritesApi + pokemonId + '.png';
    }
    createPokemonObject(id, url, name) {
        return {
            id,
            url,
            name,
            imageUrl: this.getImageUrlForPokemon(id)
        };
    }
    mapGetAllPokemonResponseToPokemonObjects(getAllPokemonResponseDto) {
        const pokemonObjects = [];
        getAllPokemonResponseDto.results.forEach((pokemon, index) => {
            const newPokemonObject = this.createPokemonObject(index + 1, pokemon.url, pokemon.name);
            pokemonObjects.push(newPokemonObject);
        });
        return pokemonObjects;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class PokemonStateWithAbstractV2Service extends AbstractStateV2Service {
    constructor(pokemonHttpService, pokemonService) {
        console.log('Initializing ' + PokemonStateWithAbstractV2Service.name);
        super();
        this.pokemonHttpService = pokemonHttpService;
        this.pokemonService = pokemonService;
        this.loadAvailableData();
    }
    ngOnDestroy() {
        console.log("Destroying " + PokemonStateWithAbstractV2Service.name);
        this.subscriptions.unsubscribe();
        this.allData.unsubscribe();
        this.selectedData.unsubscribe();
    }
    loadAvailableData() {
        this.subscriptions.add(this.allData.getSubscription(this.pokemonHttpService.getAllPokemon().pipe(map(res => this.pokemonService.mapGetAllPokemonResponseToPokemonObjects(res)))));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonStateWithAbstractV2Service, deps: [{ token: PokemonHttpWithAbstractService }, { token: PokemonService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonStateWithAbstractV2Service, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonStateWithAbstractV2Service, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: PokemonHttpWithAbstractService }, { type: PokemonService }] });

class PokemonStateWithAbstractService extends AbstractStateService {
    constructor(pokemonHttpService, pokemonService) {
        console.log('Initializing ' + PokemonStateWithAbstractService.name);
        super();
        this.pokemonHttpService = pokemonHttpService;
        this.pokemonService = pokemonService;
        this.loadAvailableData();
    }
    ngOnDestroy() {
        console.log("Destroying " + PokemonStateWithAbstractService.name);
        this.subscriptions.unsubscribe();
        this.availableData.unsubscribe();
        this.selectedData.unsubscribe();
        this.isLoadingData.unsubscribe();
    }
    loadAvailableData() {
        this.sendIsLoadingData(true);
        this.subscriptions.add(getSubscription(this.pokemonHttpService.getAllPokemon().pipe(map(res => this.pokemonService.mapGetAllPokemonResponseToPokemonObjects(res))), this.onLoadedAvailableData.bind(this), () => { console.log("Couldn't load Pokemons!"); this.sendIsLoadingData(false); }));
    }
    onLoadedAvailableData(pokemon) {
        this.sendIsLoadingData(false);
        this.sendAvailableData(pokemon);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonStateWithAbstractService, deps: [{ token: PokemonHttpWithAbstractService }, { token: PokemonService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonStateWithAbstractService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonStateWithAbstractService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: PokemonHttpWithAbstractService }, { type: PokemonService }] });

class PokemonStateService {
    constructor(pokemonHttpService, pokemonService) {
        this.pokemonHttpService = pokemonHttpService;
        this.pokemonService = pokemonService;
        this.isLoadingPokemons = new BehaviorSubject(true);
        this.availablePokemon = new BehaviorSubject([]);
        this.selectedPokemon = new BehaviorSubject(null);
        this.subscriptions = new Subscription();
        console.log('Initializing PokemonStateService');
        this.loadAllPokemon();
    }
    ngOnDestroy() {
        console.log("Destroying PokemonStateService");
        this.subscriptions.unsubscribe();
        this.availablePokemon.unsubscribe();
        this.selectedPokemon.unsubscribe();
    }
    getSyncAvailablePokemon() {
        return this.availablePokemon.getValue();
    }
    getAsyncAvailablePokemon() {
        return this.availablePokemon.asObservable();
    }
    getSyncSelectedPokemon() {
        return this.selectedPokemon.getValue();
    }
    getAsyncSelectedPokemon() {
        return this.selectedPokemon.asObservable();
    }
    getSyncIsLoadingPokemon() {
        return this.isLoadingPokemons.getValue();
    }
    getAsyncIsLoadingPokemon() {
        return this.isLoadingPokemons.asObservable();
    }
    loadAllPokemon() {
        this.sendIsLoadingPokemon(true);
        this.subscriptions.add(getSubscription(this.pokemonHttpService.getAllPokemon().pipe(map(res => this.pokemonService.mapGetAllPokemonResponseToPokemonObjects(res))), this.onLoadedAllPokemon.bind(this), () => { console.log("Couldn't load Pokemons!"); this.sendIsLoadingPokemon(false); }));
    }
    onLoadedAllPokemon(pokemon) {
        this.sendIsLoadingPokemon(false);
        this.sendAvailablePokemon(pokemon);
    }
    sendAvailablePokemon(pokemon) {
        this.availablePokemon.next(pokemon);
    }
    sendIsLoadingPokemon(isLoading) {
        this.isLoadingPokemons.next(isLoading);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonStateService, deps: [{ token: PokemonHttpService }, { token: PokemonService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonStateService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.7", ngImport: i0, type: PokemonStateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: PokemonHttpService }, { type: PokemonService }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AuctionFeatureToggle, AuthAppRoute, BestPractiseAppPokedexRoute, BestPractiseAppRoute, BestPractiseAppTwoAuctionsPokemonNameRoute, BestPractiseAppTwoAuctionsRoute, BestPractiseAppTwoRoute, ChatAppChatRoute, ChatAppChatRouterParam, ChatAppChatsCurrentUserRoute, ChatAppChatsRoute, ChatAppChatsTechnicalUserRouterQueryParam, ChatAppRoute, FeatureToggleHttpService, FeatureToggleService, GetAllPokemonResponseDto, PlatoAppRoute, PlatoCreateTwitterHandleRoute, PlatoHomeRoute, PlatoLandingRoute, PlatoLoginRoute, PlatoRegisterRoute, PlatoTwitterHandleDetailIdRoute, PlatoTwitterHandleDetailIdRouteHelper, PlatoTwitterHandleIdRouterParam, PokemonDto, PokemonHttpService, PokemonHttpWithAbstractService, PokemonNameRouterParam, PokemonService, PokemonStateService, PokemonStateWithAbstractService, PokemonStateWithAbstractV2Service };
